import React from "react";
import { useAuthentication } from "../contexts/AuthenticationContext";

const UserInfo: React.FC = () => {
  // Context
  const { isLoggedIn, user, login, logout } = useAuthentication();

  // State

  // Other

  if (!isLoggedIn) {
    return (
      <div className="UserInfo">
        <span>Not logged in.</span>
        <button onClick={login}>Log in</button>
      </div>
    )
  }

  return (
    <div className="UserInfo">
      <span>Logged in as {user?.name} ({user?.email})</span>
      <button onClick={logout}>Log out</button>
    </div>
  );
};

export default UserInfo;